import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { ICivilStatusCommonDomain } from "../interfaces/common-domain/civil-status/ICivilStatusCommonDomain";

enum CommonDomainServiceEnum {
  getBankList = "/get-bank",
  getCivilStatus = "/get-civil-status",
  getDomainByCode = "/get-domain-by-code/"

}

export default class CommonDomainService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/common-domain");
  }

  public getBankList = async (): Promise<any> => await this.GET(CommonDomainServiceEnum.getBankList);
  public getCivilStatus = async (): Promise<ICivilStatusCommonDomain> => await this.GET(CommonDomainServiceEnum.getCivilStatus);
  public getDomainByCode = async (code: string): Promise<any> => await this.GET(CommonDomainServiceEnum.getDomainByCode + code);
}



// WEBPACK FOOTER //
// ./src/services/api/CommonDomain.service.ts